export enum ReportStatus {
  New = 'new',
  Edit = 'edit',
  UnderReview = 'underReview',
  Submitted = 'submitted',
  SubmittedFeedback = 'submittedFeedback',
  NotSubmitted = 'notSubmitted',
}
